import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { PedidoClicheriaStatusMultiselectComponent } from './pedido-clicheria-status-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        PedidoClicheriaStatusMultiselectComponent
    ],
    exports: [
        PedidoClicheriaStatusMultiselectComponent
    ]
})
export class PedidoClicheriaStatusMultiselectModule { }
